"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_ui_1 = require("@pasport/react-ui");
function MinimapPoint({ onClick, map }) {
    const [over, setOver] = react_1.default.useState(false);
    return (0, jsx_runtime_1.jsx)("div", { style: {
            transform: "translate(-50%, -50%)"
        }, onClick: onClick, onMouseOver: () => setOver(true), onMouseLeave: () => setOver(false), children: (0, jsx_runtime_1.jsx)(react_ui_1.Circle, { size: over ? 16 : 6 }) });
}
exports.default = MinimapPoint;
